module.exports = __webpack_public_path__ + "media/museum.e095f380.jpg";